// BwvSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { batch } from "react-redux";
import axiosClient from "../../axios-client";

export const fetchMyservices = createAsyncThunk(
  "services/getAllServicePosts",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(`services/getAllServicePosts`, {
        params,
      });
      // dispatch(setTotalRecords(response.data.TotalRecords));
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch data"
      );
    }
  }
);

const initialState = {
  allCat: [],
  allSubCat: [],
  allItems: [],
  myServices2: [],
  myServicesLoading: false,
  myServicesError: null,
  totalVendors: 0,
  selectedService: null,
  likedCards: [],
  listOptions: [],
  activeLink: "",
  device: null,
  isReviewModalOpen: false,
  isReportingModalOpen: false,
  isInvite: false,
  endorStatus: [],
  loadingEndorse: false,
  linkModal: false,
  isModalOpen: false,
  quoteModal: false,
  quotePop: null,
  selectedServiceDate: "",
  selectedPackage: null,
  contractTerm: null,
  dealTerm: null,
  selectedPackageRate: null,
  bwvSearchQuery: "",
  searchTerm: "",
  selectedQuary: null,
  searchText: "",
  selectedOption: null,
  selectedOptionData: null,
  selectedCat: null,
  selectedSubCat: null,
  selectedItem: null,
  viewers: 0,
  viewCount: 0,
  dropdownOpen: false,
  currentPage: 1,
  sortBy: "",
  activeGridTab: "",
  radius: 15,
  selectedBusinessDetails: "",
  searchTextServices: "",
};

const BwvSlice = createSlice({
  name: "serviceDetails",
  initialState,
  reducers: {
    resetVendorDetailsState: (state) => {
      state.currentPage = 1;
      state.sortBy = "";
      state.selectedOption = null;
      state.selectedOptionData = null;
      state.selectedCat = null;
      state.selectedSubCat = null;
      state.selectedItem = null;
      state.searchTerm = "";
      state.bwvSearchQuery = "";
      state.searchText = "";
      state.selectedQuary = null;
    },
    resetBwvFilters: (state) => {
      state.currentPage = 1;
      state.sortBy = "";
      state.selectedOption = null;
      state.selectedOptionData = null;
      state.selectedCat = null;
      state.selectedSubCat = null;
      state.selectedItem = null;
      state.searchTerm = "";
      state.radius = 15;
      state.selectedBusinessDetails = "";
    },
    setAllCat: (state, action) => {
      state.allCat = action.payload;
    },
    setAllSubCat: (state, action) => {
      state.allSubCat = action.payload;
    },
    setAllItems: (state, action) => {
      state.allItems = action.payload;
    },
    setTotalVendors: (state, action) => {
      state.totalVendors = action.payload;
    },
    setSelectedService: (state, action) => {
      state.selectedService = action.payload;
    },
    setLikedCards: (state, action) => {
      state.likedCards = action.payload;
    },
    setListOptions: (state, action) => {
      state.listOptions = action.payload;
    },
    setActiveLink: (state, action) => {
      state.activeLink = action.payload;
    },
    setDevice: (state, action) => {
      state.device = action.payload;
    },
    setIsReviewModalOpen: (state, action) => {
      state.isReviewModalOpen = action.payload;
    },
    setIsReportingModalOpen: (state, action) => {
      state.isReportingModalOpen = action.payload;
    },
    setIsInvite: (state, action) => {
      state.isInvite = action.payload;
    },
    setEndorStatus: (state, action) => {
      state.endorStatus = action.payload;
    },
    setLoadingEndorse: (state, action) => {
      state.loadingEndorse = action.payload;
    },
    setLinkModal: (state, action) => {
      state.linkModal = action.payload;
    },
    setIsModalOpen: (state, action) => {
      state.isModalOpen = action.payload;
    },
    setQuoteModal: (state, action) => {
      state.quoteModal = action.payload;
    },
    setQuotePop: (state, action) => {
      state.quotePop = action.payload;
    },
    setSelectedServiceDate: (state, action) => {
      state.selectedServiceDate = action.payload;
    },
    setSelectedPackage: (state, action) => {
      state.selectedPackage = action.payload;
    },
    setContractTerm: (state, action) => {
      state.contractTerm = action.payload;
    },
    setdealTerm: (state, action) => {
      state.dealTerm = action.payload;
    },

    setSelectedPackageRate: (state, action) => {
      state.selectedPackageRate = action.payload;
    },
    setBwvSearchQuery: (state, action) => {
      state.bwvSearchQuery = action.payload;
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    setSelectedQuary: (state, action) => {
      state.selectedQuary = action.payload;
    },
    setSearchText: (state, action) => {
      state.searchText = action.payload;
    },
    setSelectedOption: (state, action) => {
      state.selectedOption = action.payload;
    },
    setSelectedOptionData: (state, action) => {
      state.selectedOptionData = action.payload;
    },
    setSelectedCat: (state, action) => {
      state.selectedCat = action.payload;
    },
    setSelectedSubCat: (state, action) => {
      state.selectedSubCat = action.payload;
    },
    setSelectedItem: (state, action) => {
      state.selectedItem = action.payload;
    },
    setViewers: (state, action) => {
      state.viewers = action.payload;
    },
    setViewCount: (state, action) => {
      state.viewCount = action.payload;
    },
    setDropdownOpen: (state, action) => {
      state.dropdownOpen = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setSortBy: (state, action) => {
      state.sortBy = action.payload;
    },
    setActiveGridTab: (state, action) => {
      state.activeGridTab = action.payload;
    },
    setRadius: (state, action) => {
      state.radius = action.payload;
    },
    setSelectedBusinessDetails: (state, action) => {
      state.selectedBusinessDetails = action.payload;
    },
    setSearchTextServices: (state, action) => {
      state.searchTextServices = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyservices.pending, (state) => {
        state.myServicesLoading = true;
        state.myServicesError = null;
      })
      .addCase(fetchMyservices.fulfilled, (state, action) => {
        state.myServicesLoading = false;
        state.myServices2 = action.payload.Data;
        state.totalVendors = action.payload.TotalRecords;
        state.myServicesError = null;
      })
      .addCase(fetchMyservices.rejected, (state, action) => {
        state.myServicesLoading = false;
        state.myServicesError = action.payload || "Failed to fetch services";
      });
  },
});

export const {
  resetVendorDetailsState,
  resetBwvFilters,
  setAllCat,
  setAllSubCat,
  setAllItems,
  setLikedCards,
  setSelectedService,
  setListOptions,
  setActiveLink,
  setDevice,
  setIsReviewModalOpen,
  setIsReportingModalOpen,
  setIsInvite,
  setEndorStatus,
  setLoadingEndorse,
  setLinkModal,
  setIsModalOpen,
  setQuoteModal,
  setQuotePop,
  setSelectedPackage,
  setContractTerm,
  setdealTerm,
  setSelectedServiceDate,
  setSelectedPackageRate,
  setBwvSearchQuery,
  setSearchText,
  setSearchTerm,
  setSelectedQuary,
  setSelectedOption,
  setSelectedOptionData,
  setSelectedCat,
  setSelectedSubCat,
  setSelectedItem,
  setViewers,
  setViewCount,
  setDropdownOpen,
  setCurrentPage,
  setSortBy,
  setActiveGridTab,
  setRadius,
  setSelectedBusinessDetails,
  setSearchTextServices,
} = BwvSlice.actions;

export default BwvSlice.reducer;
